import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaChartLine, FaCalendarCheck, FaDownload } from "react-icons/fa";
import { baseurl } from "../Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

export default function ReportSetting() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

  const orgId = localStorage.getItem("organization_id");
  const adminId = localStorage.getItem("adminID");

  // Report scheduling state
  const [scheduleType, setScheduleType] = useState("daily");
  const [showReportSchedule, setShowReportSchedule] = useState(false);

  useEffect(() => {
    if (!adminId) navigate("/");

    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);

    // Fetch current schedule from backend
    fetchReportSchedule();
  }, [navigate, adminId]);

  const fetchReportSchedule = async () => {
    try {
      const res = await axios.get(
        `${baseurl}getReportSchedule?adminId=${adminId}&orgId=${orgId}`
      );

      if (res.data.success && res.data.data) {
        setScheduleType(res.data.data.schedule_type);
      }
    } catch (err) {
      console.error("❌ Failed to fetch report schedule:", err);
    }
  };

  // Save report schedule
  const handleReportSchedule = async () => {
    try {
      await axios.post(`${baseurl}updateReportSchedule`, {
        adminId,
        orgId,
        scheduleType,
      });

      Swal.fire({
        icon: "success",
        title: "Report Schedule Updated",
        text: `You will now receive reports ${scheduleType}.`,
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("❌ Failed to update schedule:", err);
      Swal.fire("Error", "Could not update schedule", "error");
    }
  };

  return (
    <>
      <div className="settings-header">
        <h3>Metrics & Reporting</h3>
      </div>

      <div className="settings-menu">
        {/* KPI & Dashboard */}
        <div
          className="settings-menu-item"
          onClick={() => window.open("/kpi-dashboard", "_blank")}
          style={{ cursor: "pointer" }}
        >
          <div className="menu-icon">
            <FaChartLine />
          </div>
          <div className="menu-label">KPI & Dashboard</div>
          <div className="menu-arrow">›</div>
        </div>

        {/* Report Scheduling */}
        <div
          className="settings-menu-item"
          onClick={() => setShowReportSchedule(!showReportSchedule)}
          style={{ cursor: "pointer" }}
        >
          <div className="menu-icon">
            <FaCalendarCheck />
          </div>
          <div className="menu-label">Report Scheduling</div>
          <div className="menu-arrow">
            {showReportSchedule ? "▼" : "›"}
          </div>
        </div>

        {showReportSchedule && (
          <div className="settings-subsection" style={{ padding: "10px 20px" }}>
            <label>Select Schedule:</label>
            <select
              value={scheduleType}
              onChange={(e) => setScheduleType(e.target.value)}
              className="form-control"
              style={{ marginTop: "5px" }}
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>

            <button
              className="btn btn-primary mt-3"
              onClick={handleReportSchedule}
            >
              Save
            </button>
          </div>
        )}

        {/* Export Data */}
        <div
          className="settings-menu-item"
          onClick={() => window.open("/export-reports", "_blank")}
          style={{ cursor: "pointer" }}
        >
          <div className="menu-icon">
            <FaDownload />
          </div>
          <div className="menu-label">Export Data</div>
          <div className="menu-arrow">›</div>
        </div>
      </div>
    </>
  );
}
